module.exports = __webpack_public_path__ + "img/round-record_voice_over-24px.4cb65045.svg";